import * as actionTypes from "./PolicyType";

const INITIAL_STATE = {
    categoryList: [],
    accountList: [],
    categoryLimitItem: [],
    mileageItem: [],
    perDiemItem: [],
    tripItem: {},
    policyItems: [],
    policyList: [],
    policyData: [],
    advanceTypeItem: {},
    expenseTypeItem: {}
};

const PolicyReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case actionTypes.SAVECATEGORYITEM:
            return {
                ...state, categoryLimitItem: action.payload.data
            };
        case actionTypes.SAVEMILEAGEITEM:
            return {
                ...state, mileageItem: action.payload.data
            };
        case actionTypes.SAVEPERDIEMITEM:
            return {
                ...state, perDiemItem: action.payload.data
            };
        case actionTypes.SAVETRIPITEM:
            return {
                ...state, tripItem: action.payload.data
            };
        case actionTypes.SAVEPOLICYITEM:
            return {
                ...state, policyItems: action.payload.data
            };
        case actionTypes.SETPOLICY:
            return {
                ...state, policyList: action.payload.list
            };
        case actionTypes.SETPOLICYLIST:
            return {
                ...state, policyData: action.payload.list
            };
        case actionTypes.SAVEADVANCETYPEITEM:
            return {
                ...state, advanceTypeItem: action.payload.data
            };
        case actionTypes.SAVEEXPENSETYPEITEM:
            return {
                ...state, expenseTypeItem: action.payload.data
            };
        case actionTypes.CLEARDOC:
            return {
                categoryLimitItem: [],
                mileageItem: [],
                perDiemItem: [],
                tripItem: {},
                advanceTypeItem: {},
                expenseTypeItem: {}
            };
        default:
            return state;
    }
}

export default PolicyReducer;